import script from "./EVTariffSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./EVTariffSection.vue?vue&type=script&lang=ts&setup=true"

import "./EVTariffSection.vue?vue&type=style&index=0&id=2bf65fe1&lang=scss&scoped=true"

import exportComponent from "/Users/lyon/Desktop/Work s2j/app-rentalcar-project/admin-v3 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bf65fe1"]])

export default __exports__